module.exports = __webpack_public_path__ + "static/media/iso.053f443f.pdf";